import classNames from 'classnames';
import { oneOfType, string } from 'prop-types';
import React from 'react';
import { ResponsiveImage } from '../../components/';
import { ASPECT_HEIGHT_LISTING, ASPECT_WIDTH_LISTING } from '../../config/configLayout';
import { propTypes } from '../../util/types';

import css from './ListingImage.module.css';

// Match homepage ListingCard: listing-card crop variants (157:74).
const LISTING_IMAGE_SIZES = '96px';
const LISTING_IMAGE_VARIANTS = ['listing-card', 'listing-card-2x'];

export const ListingImage = props => {
  const { rootClassName, className, listing } = props;
  const classes = classNames(rootClassName || css.root, className);

  const hasImages = listing?.images && listing.images.length > 0;
  const firstImage = hasImages ? listing.images[0] : null;
  const listingTitle = listing?.attributes?.title || '';

  if (hasImages) {
    return (
      <div
        className={classes}
        style={{
          // Keep CSS aspect in sync with configLayout listing-card crop.
          aspectRatio: `${ASPECT_WIDTH_LISTING} / ${ASPECT_HEIGHT_LISTING}`,
        }}
      >
        <ResponsiveImage
          rootClassName={css.listingImage}
          alt={listingTitle}
          image={firstImage}
          variants={LISTING_IMAGE_VARIANTS}
          sizes={LISTING_IMAGE_SIZES}
        />
      </div>
    );
  } else {
    // Show placeholder if no images
    return (
      <div
        className={classes}
        style={{
          aspectRatio: `${ASPECT_WIDTH_LISTING} / ${ASPECT_HEIGHT_LISTING}`,
        }}
      >
        <div className={css.placeholder}></div>
      </div>
    );
  }
};

ListingImage.defaultProps = {
  className: null,
  rootClassName: null,
  listing: null,
};

ListingImage.propTypes = {
  rootClassName: string,
  className: string,
  listing: oneOfType([propTypes.listing, propTypes.ownListing]),
};

export default ListingImage;
